<template>
  <b-col>
    <b-card
      v-if="!id"
      sub-title="Moje narodeninové pohľadničky"
      header="Narodeniny"
      text-variant="dark"
    >
      <b-row>
        <b-col
          v-for="(item, index) in data"
          :key="index"
          deck
          sm="12"
          md="6"
          lg="4"
          style="margin-top:5px"
        >
          <postcard
            :source-pictutes="data[index].pictutes"
            :title-img="data[index].title"
            :details-img="data[index].details"
            :size-img="data[index].size"
            :material-img="data[index].material"
            :kind-img="data[index].img"
            :path-img="/narodeniny/ + data[index].id"
          />
        </b-col>
      </b-row>
    </b-card>
    <router-view/>
  </b-col>
</template>

<script>
import Picture from "./Picture"
import { ref, watch } from "@vue/composition-api"
export default {
  name: 'Narodeniny',
  components: {
    'postcard': Picture
  },
  setup(params, context) {
    const id = ref(false)
    if (context.root.$route.params.id) {
      id.value = true
    }
    watch(() => context.root.$route.params.id, (value) => { value ? id.value = true : id.value = false })
    const data = ref([
      {
        pictutes: ['/static/images/narodeniny/narodeniny1.jpg','/static/images/narodeniny/narodeniny2.jpg'],
          title: "Horúca čokoláda - 5 €",
          subtitle: "Pohľadnica",
          details: "...zaručený recept na dobrú náladu horúca čokoláda so šľahačkou :) ...pošlite ju na pohľadnici, motív bol vytvorený technikou decoupage, ručne vyrezaný a nalepený v 3D efekte, dozdobené špagátikom a kvapkami čokolády (enamelové aplikácie) a textom -pre teba- (pečiatka). Pridanou hodnotu tejto pohľadničky je ručne robená obálka na  mieru.",
          size: "15 x 10,5 cm",
          material: "obyčajný papier, špagát, kartón",
          kind: "decoupage, cardmaking, lepenie",
          id: 3
      },
      {
        pictutes: ['/static/images/narodeniny/narodeniny3.jpg'],
        title: "Muffinková - 4,50 €",
        subtitle: "Pohľadnica",
        details: "...sladká muffinková pohľadnica vhodná k pre narodeninových alebo meninových oslávencov, bola vyrobená technikou decoupage, muffinky ručne vyrezané a nalepené v 3D efekte, dozdobené pečiatkou -Blahoželanie-. Pridanou hodnotou tejto pohľadničky je ručne robená obálka na mieru.",
        size: "15 x 10,5 cm",
        material: "obyčajný papier, kartón",
        kind: "decoupage, cardmaking, lepenie",
        id: 2
      },
      {
        pictutes: ['/static/images/narodeniny/narodeniny4.jpg','/static/images/narodeniny/narodeniny5.jpg','/static/images/narodeniny/narodeniny6.jpg'],
        title: "Baletka - 4,20 €",
        subtitle: "Pohľadnica",
        details: "....pre princeznú k narodeninám :) ...otváracia pohľadnica s motívom baletky, ten bol vytvorený technikou decoupage, nalepený v 3d efekte. Pohľadnica je vrstvená, v bielej farbe, bez textov, dozdobená drobnými perličkami a previazaná ružovobielym motúzikom. Posielam s ručne robenou obálkou a visačkou :)",
        size: "14,5 x 10,5",
        material: "obyčajný papier, kartón, špagát",
        kind: "decoupage, lepenie, cardmaking",
        id: 1
      }
    ])
    return {
      data,
      id
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Narodeniny.vue